module.exports = __webpack_public_path__ + "static/terms-f0342e664e04b279ba4b1575839fd24e.png";